import type { RequestFn } from '../http';

/** CRM-Kategorie der Firma (dieselbe Klassifizierung wie in der Anrufer-Triage). */
export type CustomerType = 'CUSTOMER' | 'SALES_LEAD' | 'SUPPLIER' | 'PARTNER';

export interface ContactDirectoryEntry {
  id: string;
  name: string;
  email: string | null;
  phone: string | null;
  department: string | null;
  position: string | null;
  notes: string | null;
  customerId: string | null;
  customer: { id: string; name: string } | null;
  /** Kategorie = CustomerType der Firma; null wenn kein Kunde verknüpft ist. */
  customerType: CustomerType | null;
  isPortalUser: boolean;
  /** Echter Eintragstyp: employee = pflegbar; portal/synced/caller = read-only CustomerContact */
  kind?: 'employee' | 'portal' | 'synced' | 'caller';
}

export interface ContactDirectoryWriteInput {
  name: string;
  email?: string | null;
  phone?: string | null;
  department?: string | null;
  position?: string | null;
  notes?: string | null;
  customerId: string;
}

export interface ContactDirectoryPatchInput {
  name?: string;
  email?: string | null;
  phone?: string | null;
  department?: string | null;
  position?: string | null;
  notes?: string | null;
  /** Kategorie der Firma — wirkt firmenweit. */
  customerType?: CustomerType;
}

export function createContactDirectoryApi(request: RequestFn) {
  return {
    async listContacts(params: {
      q?: string;
      customerId?: string;
      customerType?: CustomerType;
      page?: number;
      limit?: number;
    } = {}) {
      const qs = new URLSearchParams();
      if (params.q) qs.set('q', params.q);
      if (params.customerId) qs.set('customerId', params.customerId);
      if (params.customerType) qs.set('customerType', params.customerType);
      if (params.page !== undefined) qs.set('page', String(params.page));
      if (params.limit !== undefined) qs.set('limit', String(params.limit));
      const query = qs.toString();
      return request<{
        items: ContactDirectoryEntry[];
        hasMore: boolean;
        total: number;
      }>(`/api/contact-directory${query ? `?${query}` : ''}`);
    },

    async createDirectoryContact(data: ContactDirectoryWriteInput) {
      return request<{ item: ContactDirectoryEntry }>(
        '/api/contact-directory',
        { method: 'POST', body: JSON.stringify(data) }
      );
    },

    async updateContact(id: string, data: ContactDirectoryPatchInput) {
      return request<{ item: ContactDirectoryEntry }>(
        `/api/contact-directory/${id}`,
        { method: 'PATCH', body: JSON.stringify(data) }
      );
    },

    async deleteContact(id: string) {
      return request<{ ok: boolean }>(
        `/api/contact-directory/${id}`,
        { method: 'DELETE' }
      );
    },
  };
}
